import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageToggle({ className = '' }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'fr').slice(0, 2);
  const next = current === 'fr' ? 'en' : 'fr';
  const flag = current === 'fr' ? '🇫🇷' : '🇬🇧';
  const label = current === 'fr' ? 'FR' : 'EN';

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(next)}
      data-testid="lang-toggle"
      aria-label="Changer la langue"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold text-slate-300 hover:text-white hover:bg-white/5 border border-white/10 hover:border-white/20 transition-colors ${className}`}
    >
      <span className="text-sm leading-none">{flag}</span>
      <span>{label}</span>
    </button>
  );
}
